import { useState, useEffect } from 'react';
import { useDecision } from '@optimizely/react-sdk';

type CampaignConfig = {
  excludeTargetLocation: boolean;
  addressPropertyKey: string;
  targetLocation: string[];
  pointsDisclaimerSymbol: string;
  promotionalSashMessage: string;
};

type ReturnVariables = {
  message?: string;
  additionalTermsAndConditions?: string;
  priceMessages?: string;
  replaceQffFinalTerms?: boolean;
  termsAndConditions?: string;
  title?: string;
  isGeoTargeted?: boolean;
  campaignGeoConfig?: CampaignConfig;
};

type Result = {
  isReady: boolean;
  isStandardCampaignEnabled: boolean;
} & ReturnVariables;

const FEATURE_FLAG_NAME = 'qantas-hotels-blue-banner-message';

const useStandardCampaign = (): Result => {
  const [decision, isReady] = useDecision(FEATURE_FLAG_NAME, {
    autoUpdate: true,
  });

  const [returnVariables, setReturnVariables] = useState<ReturnVariables>({});
  const [isStandardCampaignEnabled, setIsStandardCampaignEnabled] = useState(false);

  useEffect(() => {
    if (!isReady) {
      return;
    }

    setIsStandardCampaignEnabled(decision.enabled);

    if (decision.enabled) {
      setReturnVariables(decision.variables as ReturnVariables);
    }
  }, [decision, isReady]);

  return {
    isReady,
    isStandardCampaignEnabled,
    ...returnVariables,
  };
};

export default useStandardCampaign;
